// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"c027af20","703":"05617f9c"}[chunkId] + ".chunk.js";
};